import { gql } from "@apollo/client";

export const clients = gql`
query Da_Clients {
  aatmsv4_clients(where: {active: {_eq: true}}) {
    clientsid
    clientname
    contactperson
    contactemail
    department
    footer
    headerrh1
    headerrh2
    headerrh3
    landingmessage
    groundmessage
    simulatormessage
    aircraftmessage
    crewmessage
    managermessage
    logo
    active
    _crew
    _ground
    _simulator
    _aircraft
    _manager
    _optimiser
  }
}`;
export const clients2 = gql`
query Da_Clients {
  aatmsv4_clients(where: {active: {_eq: false}}) {
    clientsid
    clientname
    contactperson
    contactemail
    department
    footer
    headerrh1
    headerrh2
    headerrh3
    landingmessage
    groundmessage
    simulatormessage
    aircraftmessage
    crewmessage
    managermessage
    logo
    active
    _crew
    _ground
    _simulator
    _aircraft
    _manager
    _optimiser
  }
}`;

export const insert_aatms_clients = gql`
  mutation Da_Clients_Add(
    $clientname: String!
    $department: String!
    $headerrh1: String!
    $headerrh2: String!
    $headerrh3: String!
    $footer: String!
    $contactemail: String!
    $contactperson: String!
    $crewmessage: String!
    $mainmessage: String!
    $managermessage: String!
    $aircraftmessage: String!
    $simulatormessage: String!
    $groundmessage: String!
    $logo: String
    $landingmessage: String!
  ) {
    insert_aatmsv4_clients(objects: {
      clientname: $clientname, 
      contactperson: $contactperson, 
      contactemail: $contactemail, 
      department: $department, 
      footer: $footer, 
      headerrh1: $headerrh1, 
      headerrh2: $headerrh2, 
      headerrh3: $headerrh3, 
      landingmessage: $landingmessage, 
      crewmessage: $crewmessage, 
      groundmessage: $groundmessage, 
      simulatormessage: $simulatormessage, 
      aircraftmessage: $aircraftmessage, 
      managermessage: $managermessage, 
      logo: $logo,
      active: true, 
      _crew: true, 
      _ground: true, 
      _simulator: true, 
      _aircraft: true, 
      _manager: true, 
      _optimiser: true}) {
      returning {
        clientsid
        clientname
        contactperson
        contactemail
        department
        footer
        headerrh1
        headerrh2
        headerrh3
        landingmessage
        aircraftmessage
        simulatormessage
        managermessage
        groundmessage
        crewmessage
        active
        _crew
        _ground
        _simulator
        _aircraft
        _manager
        _optimiser
      }
    }
  }
`
export const update_aatms_clients = gql`
mutation da_clients_edit(
     $id: uuid! 
     $clientname: String!
     $department: String!
     $headerrh1: String!
     $headerrh2: String!
     $headerrh3: String!
     $footer: String!
     $logo: String!
     $contactemail: String!
     $contactperson: String!
     $crewmessage: String!
     $managermessage: String!
     $aircraftmessage: String!
     $simulatormessage: String!
     $groundmessage: String!
     $landingmessage: String!
) {
  update_aatmsv4_clients(where: {clientsid: {_eq: $id}},
   _set: {clientname: $clientname, contactperson: $contactperson, contactemail: $contactemail, department: $department, footer: $footer, 
   headerrh1: $headerrh1, headerrh2: $headerrh2, headerrh3: $headerrh3, landingmessage: $landingmessage, crewmessage: $crewmessage, groundmessage: $groundmessage, 
   simulatormessage: $simulatormessage, aircraftmessage: $aircraftmessage, managermessage: $managermessage, active: true, _crew: true, _ground: true,
    _simulator: true, _aircraft: true, _manager: true, _optimiser: true, logo: $logo}) {
    returning {
      clientsid
      clientname
      contactperson
      contactemail
      department
      footer
      headerrh1
      headerrh2
      headerrh3
      landingmessage
      crewmessage
      groundmessage
      simulatormessage
      aircraftmessage
      managermessage
      active
      _crew
      _ground
      _simulator
      _aircraft
      _manager
      _optimiser
      logo
    }
  }
}
`;
